type RefreshFn = () => Promise<boolean>;

let isAnonymousFlag = false;
let token: string | null = null;
let refreshFn: RefreshFn | null = null;
let inFlightRefresh: Promise<boolean> | null = null;

export const anonymousSessionState = {
  get isAnonymous(): boolean {
    return isAnonymousFlag;
  },
  get token(): string | null {
    return token;
  },
  setSession(value: string): void {
    isAnonymousFlag = true;
    token = value;
  },
  clearSession(): void {
    isAnonymousFlag = false;
    token = null;
  },
  registerRefresh(fn: RefreshFn): void {
    refreshFn = fn;
  },
  unregisterRefresh(fn: RefreshFn): void {
    if (refreshFn === fn) {
      refreshFn = null;
    }
  },
  refreshSession(): Promise<boolean> {
    if (!refreshFn) return Promise.resolve(false);
    if (inFlightRefresh) return inFlightRefresh;
    inFlightRefresh = refreshFn().finally(() => {
      inFlightRefresh = null;
    });
    return inFlightRefresh;
  },
};
